export default "__VITE_ASSET__C7Ki$r_m__"